import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import Strings from '../../../Strings';
import { GET_DELIVERY_FOLLOWUPS_RESULT, shippingActions } from '../../Shipping/actions';
import { ShippingTabs } from '../../Shipping';

function RecentDeliveries(props) {
  const { getData, onClick, refreshTimestamp } = props;
  const [data, setData] = React.useState('-');

  React.useEffect(() => {
    getData().then(resp => {
      if (resp?.type === GET_DELIVERY_FOLLOWUPS_RESULT) {
        setData(resp?.response?.data?.length ?? '-');
      }
    });
  }, [refreshTimestamp]);

  return (
    <div
      className="boxWithVl-box"
      data-tooltip-id="tooltip"
      data-tooltip-content={Strings.widgets.recentDeliveriesTooltip}
    >
      <div className="boxWithVl-valueBox black">{data}</div>
      <div
        onClick={() => onClick(`${ShippingTabs.SHIPPING_ORDERS.url}?tab=recent`)}
        className="boxWithVl-labelBox clickable"
      >
        {Strings.shipping.recentDeliveries}
      </div>
    </div>
  );
}

RecentDeliveries.widgetId = 'RecentDeliveriesWidget';

RecentDeliveries.propTypes = {
  getData: PropTypes.func,
  onClick: PropTypes.func,
  refreshTimestamp: PropTypes.number,
};

const mapDispatchToProps = dispatch => ({
  getData: () => dispatch(shippingActions.getDeliveryFollowups()),
  onClick: path => dispatch(push(path)),
});

export default connect(null, mapDispatchToProps)(RecentDeliveries);
